import { useRef, useEffect, useMemo, useState, useCallback } from 'react';
export function useWillUpdate(handler, depedencies) {
  var didMount = useRef(false);
  useMemo(function () {
    if (didMount.current) {
      handler();
    }
  }, depedencies);
  useEffect(function () {
    didMount.current = true;
  }, [didMount]);
}
export function useForceUpdate() {
  // eslint-disable-next-line no-unused-vars
  var _useState = useState(false),
    setFlag = _useState[1];
  var forceUpdate = useCallback(function () {
    setFlag(function (f) {
      return !f;
    });
  }, [setFlag]);
  return forceUpdate;
}
function debounce(fn, wait) {
  var timer;
  var debouncedFn = function debouncedFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      fn.apply(void 0, args);
      timer = null;
    }, wait);
  };
  return debouncedFn;
}
export function useDebounceFn(fn, wait) {
  var fnRef = useRef();
  var _useRef = useRef({
      debounced: null,
      initialized: false
    }),
    current = _useRef.current;
  var persistedFn = useCallback(
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  function () {
    return fnRef.current && fnRef.current.apply(fnRef, arguments);
  }, [fnRef]);
  fnRef.current = fn;
  if (!current.initialized) {
    current.debounced = wait === -1 ? persistedFn : debounce(persistedFn, wait);
    current.initialized = true;
  }
  return current.debounced;
}